// "Adicionar pagamento" (dividir). Valores digitados da direita para a esquerda
// (CampoCentavos, pedido do dono 29/09/2026). No Dinheiro pergunta direto o
// "Valor recebido" (vazio = valor exato), como o Dinheiro sem divisão.
import CampoCentavos from "./CampoCentavos";

const reais = (v) => v.toFixed(2).replace(".", ",");
// PIX online, cartão online e afins não entram no Dividir: o servidor recusa
// pagamento dividido com parte online (30/09/2026).
const ehOnline = (pm) => /online/i.test(`${pm.id || ""} ${pm.code || ""}`);

export default function ModalDividir({ ctx }) {
  const { showSplitModal, setShowSplitModal, splitSelectedMethod, setSplitSelectedMethod, splitAmount, setSplitAmount, splitTrocoAmount, setSplitTrocoAmount, payments, isCashMethod, splitRemaining, handleAddSplitPayment } = ctx;
  const valorParte = parseFloat(splitAmount) || 0;
  const dinheiro = isCashMethod(splitSelectedMethod);
  const recebido = parseFloat(splitTrocoAmount) || 0;
  const faltaRecebido = dinheiro && recebido > 0 && recebido < valorParte - 0.005;
  const podeAdicionar = !!splitSelectedMethod && valorParte > 0 && !faltaRecebido;
  const formas = payments.filter((pm) => !ehOnline(pm));
  const enter = (e) => { if (e.key === "Enter" && podeAdicionar) handleAddSplitPayment(); };
  return (<>
{showSplitModal && (
  <div role="dialog" aria-modal="true" aria-label="Adicionar pagamento" className="fixed inset-0 z-[60] bg-black/70 flex items-center justify-center px-6">
    <div className="bg-zinc-900 rounded-2xl p-6 max-w-md w-full shadow-2xl border border-zinc-700 space-y-6">
      <div className="text-center">
        <h3 className="text-2xl font-black text-zinc-100">Adicionar Pagamento</h3>
        <p className="text-zinc-400 text-sm mt-1">
          Restante: <span className="font-bold text-orange-500">R$ {splitRemaining.toFixed(2).replace('.', ',')}</span>
        </p>
      </div>

      {/* Seleção de forma */}
      <div className="grid grid-cols-2 gap-3">
        {formas.map((pm) => (
          <button key={pm.id} onClick={() => { setSplitSelectedMethod(pm.id); setSplitTrocoAmount(''); }} className={`p-4 rounded-xl border-2 flex flex-col items-center gap-2 transition-all ${splitSelectedMethod === pm.id ? "border-orange-500 bg-orange-500/10" : "border-zinc-700 bg-zinc-800 hover:border-zinc-600"}`}>
            <pm.icon className={`w-8 h-8 ${splitSelectedMethod === pm.id ? "text-orange-500" : "text-zinc-400"}`} />
            <span className={`text-sm font-semibold ${splitSelectedMethod === pm.id ? "text-orange-500" : "text-zinc-300"}`}>{pm.label}</span>
          </button>
        ))}
      </div>

      {/* Valor */}
      {splitSelectedMethod && (
        <div>
          <label className="text-sm text-zinc-400 mb-2 block">Valor</label>
          <div className="relative">
            <span className="absolute left-4 top-1/2 -translate-y-1/2 text-xl font-bold text-orange-500">R$</span>
            <CampoCentavos
              valor={splitAmount}
              onValor={setSplitAmount}
              onKeyDown={enter}
              data-e2e="dividir-valor"
              className="w-full pl-14 pr-4 h-14 text-xl font-bold bg-zinc-800 border border-zinc-700 text-zinc-100 rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
              autoFocus
            />
          </div>
        </div>
      )}

      {/* Dinheiro: quanto o cliente entregou (vazio = valor exato) */}
      {dinheiro && valorParte > 0 && (
        <div className="space-y-2">
          <label className="text-sm text-zinc-400 block">Valor recebido em dinheiro <span className="text-zinc-500">(vazio = valor exato)</span></label>
          <div className="relative">
            <span className="absolute left-4 top-1/2 -translate-y-1/2 text-lg font-bold text-green-500">R$</span>
            <CampoCentavos
              valor={splitTrocoAmount}
              onValor={setSplitTrocoAmount}
              onKeyDown={enter}
              placeholder={reais(valorParte)}
              data-e2e="dividir-recebido"
              className="w-full pl-14 pr-4 h-12 text-lg font-bold bg-zinc-800 border border-zinc-700 text-zinc-100 rounded-xl placeholder:text-zinc-600 focus:ring-2 focus:ring-orange-500"
            />
          </div>
          {recebido > valorParte + 0.005 && <p className="text-sm text-green-500 font-semibold" data-e2e="dividir-troco">Troco: R$ {reais(recebido - valorParte)}</p>}
          {faltaRecebido && <p className="text-sm text-amber-500 font-semibold">Faltam R$ {reais(valorParte - recebido)}</p>}
        </div>
      )}

      {/* Botões */}
      <div className="grid grid-cols-2 gap-4">
        <button onClick={() => setShowSplitModal(false)} className="h-14 rounded-xl border-2 border-zinc-600 bg-zinc-800 hover:bg-zinc-700 text-zinc-200 font-bold transition-all">
          Cancelar
        </button>
        <button
          onClick={handleAddSplitPayment}
          disabled={!podeAdicionar}
          data-e2e="dividir-adicionar"
          className={`h-14 rounded-xl font-bold transition-all ${
            !podeAdicionar
              ? "bg-zinc-700 text-zinc-500 cursor-not-allowed"
              : "bg-orange-500 hover:bg-orange-600 text-white active:scale-95"
          }`}
        >
          Adicionar
        </button>
      </div>
    </div>
  </div>
)}
  </>);
}
